'use strict';
import template from './task-status-table.html';

export function TaskStatusTableDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      metrics: '='
    },
    controllerAs: 'table',
    bindToController: true,
    controller: ['$scope', DomainAssetTaskCardController]
  }
}

function DomainAssetTaskCardController($scope) {

}



// WEBPACK FOOTER //
// ./src/js/projects/directives/TaskStatusTableDirective.js